
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59.429 55.406H4.57a4.595 4.595 0 01-3.23-1.33A4.523 4.523 0 010 50.87V39.076h1.829V50.87c0 .722.289 1.414.803 1.924s1.212.798 1.94.798h54.857c.727 0 1.425-.287 1.94-.798a2.71 2.71 0 00.802-1.924V16.396a2.71 2.71 0 00-.803-1.924 2.754 2.754 0 00-1.94-.797H4.572c-.727 0-1.425.286-1.94.797a2.71 2.71 0 00-.802 1.924v19.051H0v-19.05a4.524 4.524 0 011.34-3.206 4.595 4.595 0 013.231-1.33H59.43a4.595 4.595 0 013.23 1.33A4.524 4.524 0 0164 16.395V50.87a4.524 4.524 0 01-1.34 3.206 4.595 4.595 0 01-3.231 1.33z","fill":"#1BA7E1"}}),_c('path',{attrs:{"d":"M54.858 20.025h8.229v1.815h-8.229v-1.815zM.914 20.025H51.2v1.815H.914v-1.815zM.914 28.19h62.172v1.814H.914v-1.815zM5.484 49.056h19.2v1.814h-19.2v-1.814zM5.484 44.52h10.057v1.814H5.484v-1.815z","fill":"#1BA7E1"}})])
          )
        }
      }
    